import React from 'react';
import OverviewCard from '../overview/OverviewCard';
import {
    ContactsOutlined,
    DollarCircleOutlined,
    ContainerOutlined,
    CheckCircleFilled,
    CalendarOutlined
} from '@ant-design/icons';

const DashboardBottom: React.FC = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">

            {/* Contacts Overview */}
            <div className="col-span-1">
                <OverviewCard
                    title="Contacts Overview"
                    data={[
                        { value: 223, label: 'Contacts Added', Icon: ContactsOutlined, iconColor: 'text-purple-500', trend: '+5.6%', trendType: 'up' },
                        { value: 147, label: 'Active Contacts', Icon: ContactsOutlined, iconColor: 'text-green-500' },
                        { value: 76, label: 'Contacts Converted', Icon: ContactsOutlined, iconColor: 'text-green-500', trend: '+5.6%', trendType: 'up' },
                    ]}
                />
            </div>

            {/* Deals Overview */}
            <div className="col-span-1">
                <OverviewCard
                    title="Deals Overview"
                    data={[
                        { value: 223, label: 'Deals Created', Icon: DollarCircleOutlined, iconColor: 'text-blue-500', trend: '+5.6%', trendType: 'up' },
                        { value: 147, label: 'Deals in Pipeline', Icon: ContainerOutlined, iconColor: 'text-orange-500', trend: '+5.6%', trendType: 'up' },
                        { value: 76, label: 'Deals Closed', Icon: CheckCircleFilled, iconColor: 'text-green-500', trend: '+5.6%', trendType: 'up' },
                    ]}
                />
            </div>

            {/* Follow-ups */}
            <div className="col-span-1">
                <OverviewCard
                    title="Follow-ups Overview"
                    data={[
                        { value: 223, label: 'Due Today', Icon: CalendarOutlined, iconColor: 'text-yellow-500', trend: '+5.6%', trendType: 'up' },
                        { value: 147, label: 'Completed', Icon: CheckCircleFilled, iconColor: 'text-green-500', trend: '+5.6%', trendType: 'up' },
                        { value: 76, label: 'Overdue', Icon: CalendarOutlined, iconColor: 'text-red-500', trend: '+5.6%', trendType: 'up' },
                    ]}
                />
            </div>

            {/* Empty Col */}
            <div className="col-span-1" />
        </div>
    );
};

export default DashboardBottom;
